import { useEffect, useRef, useState } from "react";
import { Buttton, Cards, Inputs } from "../components";
import { useTranslation } from "react-i18next";
import { FaPaperclip } from "react-icons/fa";
import { Commons } from "../utilities";

const ChatWindows = ({ loginData, joinChat, chatHistory, chat, displayName }) => {
    const { t } = useTranslation();
    const scrollRef = useRef(null);
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollTo({
                top: scrollRef.current.scrollHeight,
                // behavior: "smooth",
            });
        }
    }, [chatHistory]);
    const handleSendMessage = () => {
        if (message.trim()) {
            joinChat(loginData.userGuid, message, chat.appointmentGuid);
            setMessage("");
        }
    };

    return (
        <Cards.Cardd
            header={<h5 className="exado-title-seven card-header-text">{`${t("chat_with")} ${displayName}`}</h5>}
            content={
                <div className="chat-scroll-container" ref={scrollRef}>
                    {Array.isArray(chatHistory) &&
                        chatHistory.map((item, idx) => (
                            <div
                                className={
                                    item.userType === loginData.userType
                                        ? "doctor-message"
                                        : "patient-message"
                                }
                                key={idx}
                            >
                                <div className="usericon exado_body_text_two">
                                    {item.userType === 1 ? "D" : "P"}
                                </div>
                                <div className="show-message-txt">
                                    <div className="show-message-date exado-title-seven">
                                        {Commons.formatDate(item.createdDate)}
                                    </div>
                                    <p className="show-message-text exado-title-seven">
                                        {item.message}
                                    </p>
                                </div>
                            </div>
                        ))}
                </div>
            }
            footer={
                <>
                    <div className="blkIcon">{loginData.userType === 1 ? "D" : "P"}</div>
                    <div className="position-relative flex-grow-1">
                        <Inputs.FormInputs
                            name="message"
                            value={message}
                            onChange={(e) => setMessage(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === "Enter" && !e.shiftKey) {
                                    e.preventDefault();
                                    handleSendMessage();
                                }
                            }}
                            placeholder="Write text here"
                            grpClassname={`form-group chat-input`}
                        // disabled={!isEditVisible}
                        />
                        <FaPaperclip className="position-absolute top-50  translate-middle-y paper-clip-icon custom-cursor-pointer" />
                    </div>

                    <Buttton.Buttton
                        className="btn-solid-Aqua_Teal"
                        children={t("SEND")}
                        onClick={handleSendMessage}
                    />
                </>
            }
            className="cardd cwp-card chat-card"
        />
    );
};

export default ChatWindows;
